/* COVRFLY-SOLDOUT-BLOCK-START */
// ============================================================
// COVRFLY® — Bloqueo MagSafe + Pre-Orden
// Versión: 2.3.0
// Depende de: FINAL-covrfly-magsafe-selector.js (debe cargarse antes)
//
// ARQUITECTURA v2.x:
//   CERO MutationObservers excepto waitForWrap (espera DOM).
//   Todo via event listeners + timers + fetch.
//
// Changelog v2.3.0:
//   - PREORDER_MODELS ahora es array de objetos { model, blanksDate }.
//   - Fechas de entrega calculadas desde blanksDate (fecha fija),
//     no desde Date.now() + PREORDER_EXTRA_DAYS.
//   - Auto-expiración: si hoy > blanksDate, el Pre-Orden se
//     desactiva automáticamente (blanks ya llegaron).
//   - Removido PREORDER_EXTRA_DAYS (ya no aplica).
//
// Changelog v2.2.3:
//   - FIX: Fade-out del banner mixto — inline style.transition
//     antes de style.opacity=0 + safety setTimeout fallback.
//   - Removido transition de la regla CSS (solo vive inline).
//
// Changelog v2.2.2:
//   - STYLE: Banner mixto rediseñado (dark pill, SF Pro, fade-in/out).
//
// Changelog v2.2.1:
//   - FIX: Intercept fetch('/cart/add.js') como trigger primario
//     para patchPreorderItems (no depende solo de covrfly:cart-updated).
//   - FIX: Validar r.ok en /cart/change.js; fallback refresh en .catch.
//   - FIX: Safety timeout (10s) para resetear _cfPatching si se atasca.
//   - FIX: try/catch en checkMixedOrder para que nunca bloquee el patch.
//
// Changelog v2.2.0:
//   - QUITADO: Filtro upsell que ocultaba cards. Ya no se oculta
//     nada del "Te puede gustar".
//   - AGREGADO: Intercepta covrfly:cart-updated. Si un item del
//     carrito es Pre-Orden pero no tiene properties (vino del
//     upsell), hace PATCH via /cart/change.js para agregarle
//     _Tipo de orden + Entrega. Luego refresca el drawer.
//   - AGREGADO: Banner pedido mixto. Detecta mezcla de items
//     normales + Pre-Orden por variant_title (no por DOM props).
//     Usa datos del carrito directamente.
//
// Changelog v2.1.0:
//   - Filtro upsell + banner mixto (reemplazado en v2.2.0)
//
// Changelog v2.0.0:
//   - Rediseño completo sin MO en botón ni cart drawer
//   - Bloqueo MagSafe v1.2.1 intacto
//   - Pre-Orden: delivery, botón, properties, disclaimer
//   - Pago dinámico: ocultar via CSS class
// ============================================================
(function () {
  'use strict';

  var LOG = function () {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[COVRFLY-SOLDOUT]');
    console.log.apply(console, args);
  };
  LOG('Iniciando bloqueo MagSafe + Pre-Orden v2.3.0...');

  // ── MODELOS BLOQUEADOS (solo MagSafe) ───────────────────────
  var BLOCKED_MAGSAFE_MODELS = [];

  // ── MODELOS Pre-Orden ──────────────────────────────────────
  // blanksDate = fecha en que los blanks estarán disponibles.
  // Fechas de entrega = blanksDate + días de envío (6-8 std).
  // Auto-expiración: si hoy > blanksDate → inactivo (blanks ya llegaron).
  var PREORDER_MODELS = [
    { model: 'iPhone 17 Pro Max:No', blanksDate: '2026-04-30' }
  ];

  var SUBLABEL_BLOCKED = 'Alta demanda \u2014 disponible pronto';
  var SHIP_DAYS = { std: [6, 8], pri: [3, 5], exp: [2, 3] };
  var MESES_ES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  var ORIGINAL_BTN_TEXT = 'Agregar Al Carrito';

  // ── HELPERS ────────────────────────────────────────────────

  function normalize(str) {
    return (str || '').trim().normalize('NFC').toLowerCase();
  }

  function isBlocked(model) {
    if (!model) return false;
    var m = normalize(model);
    for (var i = 0; i < BLOCKED_MAGSAFE_MODELS.length; i++) {
      if (m === normalize(BLOCKED_MAGSAFE_MODELS[i])) return true;
    }
    return false;
  }

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  // Auto-expiración: si hoy > blanksDate → los blanks ya llegaron, delivery normal aplica
  function isExpired(entry) {
    var bd = new Date(entry.blanksDate + 'T00:00:00');
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today > bd;
  }

  // Busca el entry que matchea modelo + magsafe. Retorna null si expirado o no encontrado.
  function getPreorderEntry(model, magsafeValue) {
    if (!model) return null;
    var m = normalize(model);
    for (var i = 0; i < PREORDER_MODELS.length; i++) {
      var entry = PREORDER_MODELS[i];
      if (isExpired(entry)) continue;
      var entryModel = entry.model;
      var colonIdx = entryModel.indexOf(':');
      if (colonIdx === -1) {
        if (m === normalize(entryModel)) return entry;
      } else {
        if (m === normalize(entryModel.substring(0, colonIdx)) &&
            magsafeValue === entryModel.substring(colonIdx + 1)) return entry;
      }
    }
    return null;
  }

  function isPreorder(model, magsafeValue) {
    return getPreorderEntry(model, magsafeValue) !== null;
  }

  // Checa si CUALQUIER entry (no expirado) matchea este modelo (ignora magsafe)
  function isPreorderModel(model) {
    if (!model) return false;
    var m = normalize(model);
    for (var i = 0; i < PREORDER_MODELS.length; i++) {
      var entry = PREORDER_MODELS[i];
      if (isExpired(entry)) continue;
      var entryModel = entry.model;
      var colonIdx = entryModel.indexOf(':');
      var name = colonIdx === -1 ? entryModel : entryModel.substring(0, colonIdx);
      if (m === normalize(name)) return true;
    }
    return false;
  }

  // Extraer modelo del variant_title: "iPhone 17 Pro Max / Si" → "iPhone 17 Pro Max"
  function modelFromVariantTitle(vt) {
    if (!vt) return '';
    var parts = vt.split(' / ');
    return parts[0].trim();
  }

  function fmtDate(d) {
    return d.getDate() + ' ' + MESES_ES[d.getMonth()];
  }

  function fmtRange(d1, d2) {
    if (d1.getMonth() === d2.getMonth()) {
      return 'Llega ' + d1.getDate() + '\u2013' + d2.getDate() + ' ' + MESES_ES[d1.getMonth()];
    }
    return 'Llega ' + fmtDate(d1) + ' \u2013 ' + fmtDate(d2);
  }

  function fmtDateRange(d1, d2) {
    if (d1.getMonth() === d2.getMonth()) {
      return d1.getDate() + '\u2013' + d2.getDate() + ' ' + MESES_ES[d1.getMonth()];
    }
    return fmtDate(d1) + '\u2013' + fmtDate(d2);
  }

  // Calcula rangos de entrega desde blanksDate (fecha fija)
  function calcPreorderRanges(blanksDate) {
    var bd = new Date(blanksDate + 'T00:00:00');
    return {
      std: { s: addBusinessDays(bd, SHIP_DAYS.std[0]),
             e: addBusinessDays(bd, SHIP_DAYS.std[1]) },
      pri: { s: addBusinessDays(bd, SHIP_DAYS.pri[0]),
             e: addBusinessDays(bd, SHIP_DAYS.pri[1]) },
      exp: { s: addBusinessDays(bd, SHIP_DAYS.exp[0]),
             e: addBusinessDays(bd, SHIP_DAYS.exp[1]) }
    };
  }

  // ══════════════════════════════════════════════════════════════
  // ── CART DRAWER: PATCH PREORDER ITEMS + BANNER MIXTO ─────────
  // ══════════════════════════════════════════════════════════════
  // Sin MutationObservers. Usa evento covrfly:cart-updated +
  // fetch a /cart/change.js para agregar properties a items
  // que vinieron del upsell sin ellas.

  var _cfPatching = false;
  var _cfPatchSafety = null;

  function refreshDrawer() {
    if (window.CfCartDrawer && typeof window.CfCartDrawer.refresh === 'function') {
      return window.CfCartDrawer.refresh();
    }
    return Promise.resolve();
  }

  function patchPreorderItems(cart) {
    if (_cfPatching) { LOG('Patch: skipped (_cfPatching=true)'); return; }
    if (!cart || !cart.items) { LOG('Patch: skipped (no cart/items)'); return; }

    // Encontrar items Pre-Orden sin property "Pedido"
    var itemsToPatch = [];
    cart.items.forEach(function (item) {
      var model = modelFromVariantTitle(item.variant_title);
      var parts = (item.variant_title || '').split(' / ');
      var msVal = parts.length > 1 ? parts[1].trim() : '';
      var entry = getPreorderEntry(model, msVal);
      var hasPedido = item.properties && item.properties['Pedido'];
      if (entry && !hasPedido) {
        LOG('  Needs patch:', item.variant_title, 'key=' + item.key);
        itemsToPatch.push({ item: item, entry: entry });
      }
    });

    if (itemsToPatch.length === 0) { LOG('Patch: 0 items need patching'); return; }

    _cfPatching = true;
    LOG('Patching', itemsToPatch.length, 'item(s)...');

    // Safety timeout: unlock after 10s in case of stuck promises
    if (_cfPatchSafety) clearTimeout(_cfPatchSafety);
    _cfPatchSafety = setTimeout(function () {
      if (_cfPatching) {
        LOG('WARN: _cfPatching stuck 10s, resetting');
        _cfPatching = false;
      }
    }, 10000);

    var changeUrl = (window.routes && window.routes.cart_change_url)
      ? window.routes.cart_change_url + '.js'
      : '/cart/change.js';

    // Encadenar llamadas secuencialmente (evitar race conditions)
    var chain = Promise.resolve();
    itemsToPatch.forEach(function (patchInfo) {
      chain = chain.then(function () {
        var item = patchInfo.item;
        var R = calcPreorderRanges(patchInfo.entry.blanksDate);
        var pedidoValue = 'Pre-Orden';
        var entregaValue = fmtDateRange(R.std.s, R.std.e);
        var tipoValue = 'Pre-Orden (blanks: ' + patchInfo.entry.blanksDate + ')';

        // Merge properties existentes + nuevas
        var props = {};
        if (item.properties) {
          var keys = Object.keys(item.properties);
          for (var i = 0; i < keys.length; i++) {
            props[keys[i]] = item.properties[keys[i]];
          }
        }
        props['Pedido'] = pedidoValue;
        props['Entrega estimada'] = entregaValue;
        props['_Tipo de orden'] = tipoValue;

        LOG('  POST', changeUrl, 'key=' + item.key);
        return fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: props
          }),
          credentials: 'same-origin'
        }).then(function (r) {
          if (!r.ok) LOG('  WARN: /cart/change.js status', r.status);
          return r.json();
        });
      });
    });

    // Después de patchear, refrescar el cart drawer
    chain
      .then(function () {
        LOG('Patch done. Refreshing drawer...');
        return refreshDrawer();
      })
      .then(function () {
        LOG('Drawer refreshed OK');
        clearTimeout(_cfPatchSafety);
        _cfPatching = false;
      })
      .catch(function (err) {
        LOG('ERROR patching:', err);
        clearTimeout(_cfPatchSafety);
        _cfPatching = false;
        // Fallback: refresh anyway (some patches may have succeeded)
        LOG('Fallback: refreshing drawer after error...');
        refreshDrawer().catch(function () {});
      });
  }

  // ── Banner pedido mixto ───────────────────────────────────
  // Usa datos del carrito (variant_title) para detectar mezcla,
  // no scraping del DOM de properties. Funciona antes de patchear.

  function checkMixedOrder(cart) {
    var productsZone = document.getElementById('cf-drawer-products');
    if (!productsZone || !productsZone.parentNode) return;

    var existing = productsZone.parentNode.querySelector('.covrfly-mixed-banner');

    // Helper: fade-out → remove
    function fadeOutBanner(el) {
      if (!el || el.classList.contains('is-removing')) return;
      el.classList.add('is-removing');
      el.style.transition = 'opacity 0.4s ease';
      el.style.opacity = '0';
      var removed = false;
      el.addEventListener('transitionend', function handler() {
        el.removeEventListener('transitionend', handler);
        if (!removed && el.parentNode) { removed = true; el.parentNode.removeChild(el); }
      });
      // Safety: remove after 500ms if transitionend never fires
      setTimeout(function () {
        if (!removed && el.parentNode) { removed = true; el.parentNode.removeChild(el); }
      }, 500);
    }

    if (!cart || !cart.items || cart.items.length < 2) {
      fadeOutBanner(existing);
      return;
    }

    var hasPreorder = false;
    var hasNormal = false;

    cart.items.forEach(function (item) {
      var model = modelFromVariantTitle(item.variant_title);
      var parts = (item.variant_title || '').split(' / ');
      var msVal = parts.length > 1 ? parts[1].trim() : '';
      if (getPreorderEntry(model, msVal)) {
        hasPreorder = true;
      } else {
        hasNormal = true;
      }
    });

    var isMixed = hasPreorder && hasNormal;

    if (isMixed && !existing) {
      var banner = document.createElement('div');
      banner.className = 'covrfly-mixed-banner';
      banner.innerHTML = 'Los art\u00edculos en Pre-Orden<br>se env\u00edan por separado';
      productsZone.parentNode.insertBefore(banner, productsZone);
    } else if (!isMixed) {
      fadeOutBanner(existing);
    }
  }

  // ── Estilizar properties de Pre-Orden en el drawer ────────
  function stylePreorderProps() {
    var props = document.querySelectorAll('.cf-cart-item__prop');
    for (var i = 0; i < props.length; i++) {
      var t = props[i].textContent;
      if (t.indexOf('Pre-Orden') !== -1 || t.indexOf('Entrega estimada') !== -1) {
        props[i].style.fontWeight = '600';
        props[i].style.color = '#1d1d1f';
      }
    }
  }

  // Función combinada — try/catch para que checkMixedOrder
  // nunca bloquee patchPreorderItems
  function onCartUpdated(cart) {
    try { checkMixedOrder(cart); } catch (err) { LOG('WARN checkMixedOrder:', err); }
    stylePreorderProps();
    patchPreorderItems(cart);
  }

  // ── CSS banner mixto ──────────────────────────────────────
  var bannerCSS = document.createElement('style');
  bannerCSS.id = 'covrfly-mixed-banner-css';
  bannerCSS.textContent = [
    '@keyframes cfBannerFadeIn{from{opacity:0}to{opacity:1}}',
    '.covrfly-mixed-banner{',
      'background:#1d1d1f;',
      'color:rgba(255,255,255,0.92);',
      'border-radius:14px;',
      'padding:7px 24px;',
      'margin:0 16px 14px;',
      'font-size:15px;',
      'text-align:center;',
      'font-weight:400;',
      'line-height:1.5;',
      'letter-spacing:-0.01em;',
      'font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",sans-serif;',
      'animation:cfBannerFadeIn 0.5s ease;',
      'opacity:1',
    '}'
  ].join('');
  document.head.appendChild(bannerCSS);

  // ── Event hooks (sin MutationObservers) ───────────────────

  // HOOK 1 (primary): Intercept fetch('/cart/add.js')
  // Cuando cualquier script agrega al carrito (upsell, PDP, etc),
  // esperamos a que el cart drawer termine su ciclo, luego
  // fetch fresh cart y ejecutamos patch + banner.
  (function () {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input
        : (input instanceof Request ? input.url : '');
      var isCartAdd = url.indexOf('/cart/add') !== -1;

      var promise = origFetch.apply(this, arguments);

      if (isCartAdd) {
        promise.then(function (response) {
          if (!response.ok) return;
          LOG('Intercept: /cart/add.js OK \u2014 scheduling patch in 800ms');
          // Wait for cart drawer fetchCart+renderCart cycle (~500ms)
          setTimeout(function () {
            origFetch('/cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                LOG('Post-add cart:', cart.item_count, 'items');
                onCartUpdated(cart);
              })
              .catch(function (err) {
                LOG('WARN: post-add cart fetch failed:', err);
              });
          }, 800);
        }).catch(function () {}); // Don't interfere with original chain
      }

      return promise;
    };
  })();

  // HOOK 2 (backup): evento del cart drawer después de cada render
  document.addEventListener('covrfly:cart-updated', function (e) {
    var cart = e.detail && e.detail.cart ? e.detail.cart : null;
    if (cart) {
      setTimeout(function () { onCartUpdated(cart); }, 100);
    }
  });

  // HOOK 3 (backup): click en icono del carrito (abre drawer)
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.header__icon--cart, [href="/cart"], .cart-count-bubble, .cart-icon-bubble');
    if (cartLink) {
      setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { onCartUpdated(cart); })
          .catch(function () {});
      }, 500);
    }
  });

  LOG('Cart drawer hooks activos (intercept + event + click)');

  // ── ESPERAR AL SELECTOR DE MAGSAFE (ÚNICO MutationObserver) ─
  function waitForWrap(callback) {
    var wrap = document.getElementById('covrfly-magsafe-wrap');
    if (wrap) { callback(wrap); return; }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.id === 'covrfly-magsafe-wrap') {
            observer.disconnect();
            callback(node);
            return;
          }
          var inner = node.querySelector && node.querySelector('#covrfly-magsafe-wrap');
          if (inner) {
            observer.disconnect();
            callback(inner);
            return;
          }
        }
      }
    });

    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
      var fallback = document.getElementById('covrfly-magsafe-wrap');
      if (fallback) {
        callback(fallback);
      } else {
        LOG('TIMEOUT: #covrfly-magsafe-wrap no encontrado');
      }
    }, 5000);
  }

  // ══════════════════════════════════════════════════════════════
  // ── INIT (PDP scope) ─────────────────────────────────────────
  // ══════════════════════════════════════════════════════════════

  function init(wrap) {
    var magsafeCard = wrap.querySelector('.cf-magsafe-card.magsafe[data-value="Si"]');
    var standardCard = wrap.querySelector('.cf-magsafe-card.standard[data-value="No"]');
    if (!magsafeCard || !standardCard) { LOG('ERROR: Tarjetas no encontradas'); return; }

    var vs = document.querySelector('variant-selects');
    var modelSelect =
      (vs ? vs.querySelector('select[name="options[Elige tu Modelo]"]') : null) ||
      (vs ? vs.querySelector('select[name="options[Modelo]"]') : null) ||
      document.querySelector('select[name="options[Elige tu Modelo]"]') ||
      document.querySelector('select[name="options[Modelo]"]');

    var magsafeSelect =
      (vs ? vs.querySelector('select[name="options[MagSafe]"]') : null) ||
      document.querySelector('select[name="options[MagSafe]"]');

    if (!magsafeSelect) { LOG('ERROR: select[MagSafe] no encontrado'); return; }

    // ── ESTADO ─────────────────────────────────────────────
    var currentlyBlocked = false;
    var currentlyPreorder = false;
    var currentPreorderEntry = null;
    var guard = false;
    var pendingForce = null;

    var savedHeaderHTML = null;
    var savedDates = null;

    var sublabel = magsafeCard.querySelector('.cf-magsafe-sublabel');
    var SUBLABEL_ORIGINAL = sublabel ? sublabel.textContent : '';

    // ── ESTILOS ────────────────────────────────────────────
    var css = document.createElement('style');
    css.id = 'covrfly-soldout-styles';
    css.textContent = [
      '@keyframes cfSoldoutPulse{0%,100%{opacity:.5}50%{opacity:1}}',
      '.cf-magsafe-card.cf-soldout-disabled{pointer-events:none!important;opacity:.6!important;cursor:not-allowed!important;border-color:#e5e5e5!important;background:#fafafa!important;transform:none!important;box-shadow:none!important;transition:opacity .5s ease,background .5s ease,border-color .5s ease}',
      '.cf-magsafe-card.cf-soldout-disabled.is-selected{border-color:#e5e5e5!important;background:#fafafa!important;box-shadow:none!important}',
      '.cf-magsafe-card.cf-soldout-disabled .cf-magsafe-label{color:#b0b0b0!important}',
      '.cf-magsafe-card.cf-soldout-disabled .cf-magsafe-sublabel{color:#888!important;opacity:1!important}',
      '.cf-magsafe-card.cf-soldout-disabled .cf-magsafe-icon{color:#ccc!important}',
      '.cf-magsafe-card.cf-soldout-disabled .cf-magsafe-badge{display:none!important}',
      '.cf-magsafe-card.cf-soldout-disabled::after{display:none!important}',
      '.covrfly-hide-dynamic-checkout .shopify-payment-button{display:none!important}',
      '.covrfly-hide-dynamic-checkout .dynamic-checkout__content{display:none!important}',
      '.covrfly-hide-dynamic-checkout [data-shopify="dynamic-checkout-cart"]{display:none!important}'
    ].join('\n');
    document.head.appendChild(css);

    // ── HELPERS DINÁMICOS ──────────────────────────────────

    function getAddToCartBtn() {
      return document.querySelector('.product-form__submit[name="add"]:not(.cf-cloned-btn)') ||
             document.querySelector('button.product-form__submit:not(.cf-cloned-btn)');
    }

    function getProductForm() {
      var btn = getAddToCartBtn();
      if (btn) {
        var form = btn.closest('form');
        if (form) return form;
      }
      var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
      for (var i = 0; i < forms.length; i++) {
        if (!forms[i].closest('.product__sticky')) return forms[i];
      }
      return null;
    }

    // ══════════════════════════════════════════════════════════
    // ── BLOQUEO MAGSAFE (lógica v1.2.1 intacta) ─────────────
    // ══════════════════════════════════════════════════════════

    function forceStandard() {
      guard = true;
      magsafeSelect.value = 'No';
      magsafeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      guard = false;

      magsafeCard.classList.add('cf-soldout-disabled');
      magsafeCard.classList.remove('is-selected');
      magsafeCard.setAttribute('aria-checked', 'false');
      magsafeCard.setAttribute('tabindex', '-1');

      standardCard.classList.add('is-selected');
      standardCard.setAttribute('aria-checked', 'true');

      if (sublabel) {
        sublabel.textContent = SUBLABEL_BLOCKED;
        sublabel.style.animation = 'cfSoldoutPulse 3.5s ease-in-out infinite';
      }
    }

    function applyBlock() {
      currentlyBlocked = true;
      forceStandard();
      LOG('\ud83d\udeab Bloqueado:', modelSelect ? modelSelect.value : '(sin modelo)');
    }

    function removeBlock() {
      currentlyBlocked = false;
      if (pendingForce) { clearTimeout(pendingForce); pendingForce = null; }

      magsafeCard.classList.remove('cf-soldout-disabled');
      magsafeCard.setAttribute('tabindex', '0');

      if (sublabel) {
        sublabel.textContent = SUBLABEL_ORIGINAL;
        sublabel.style.animation = '';
      }

      LOG('\u2705 Desbloqueado');
    }

    // ══════════════════════════════════════════════════════════
    // ── Pre-Orden ────────────────────────────────────────────
    // ══════════════════════════════════════════════════════════

    function setBtnPreorder() {
      var btn = getAddToCartBtn();
      if (!btn) return;
      var span = btn.querySelector('span');
      if (span) {
        span.textContent = 'Pre-Ordenar';
      } else {
        btn.textContent = 'Pre-Ordenar';
      }
    }

    function setBtnOriginal() {
      var btn = getAddToCartBtn();
      if (!btn) return;
      var span = btn.querySelector('span');
      if (span) {
        span.textContent = ORIGINAL_BTN_TEXT;
      } else {
        btn.textContent = ORIGINAL_BTN_TEXT;
      }
    }

    function applyPreorderDelivery() {
      var dc = document.querySelector('.delivery-container');
      if (!dc) { LOG('WARN: delivery-container no encontrado'); return; }
      if (!currentPreorderEntry) { LOG('WARN: no currentPreorderEntry'); return; }

      if (savedHeaderHTML === null) {
        var h = dc.querySelector('.cvr-header');
        savedHeaderHTML = h ? h.innerHTML : '';
        savedDates = [];
        var dEls = dc.querySelectorAll('.cvr-date');
        for (var i = 0; i < dEls.length; i++) {
          savedDates.push(dEls[i].textContent);
        }
      }

      var header = dc.querySelector('.cvr-header');
      if (header) {
        header.innerHTML = '<span class="cvr-header-text">Tu entrega estimada:</span>';
      }

      var R = calcPreorderRanges(currentPreorderEntry.blanksDate);
      var dateEls = dc.querySelectorAll('.cvr-date');
      var ranges = [R.std, R.pri, R.exp];
      for (var i = 0; i < dateEls.length && i < ranges.length; i++) {
        dateEls[i].textContent = fmtRange(ranges[i].s, ranges[i].e);
      }

      var disclaimer = dc.querySelector('.cvr-disclaimer');
      if (disclaimer && !disclaimer.querySelector('.covrfly-preorder-disclaimer')) {
        var note = document.createElement('div');
        note.className = 'covrfly-preorder-disclaimer';
        note.textContent = 'Pre-Orden \u2014 Alta demanda';
        disclaimer.appendChild(note);
      }
    }

    function restorePreorderDelivery() {
      var dc = document.querySelector('.delivery-container');
      if (!dc) return;

      if (savedHeaderHTML !== null) {
        var header = dc.querySelector('.cvr-header');
        if (header) header.innerHTML = savedHeaderHTML;
      }

      if (savedDates) {
        var dateEls = dc.querySelectorAll('.cvr-date');
        for (var i = 0; i < dateEls.length && i < savedDates.length; i++) {
          dateEls[i].textContent = savedDates[i];
        }
      }

      var note = dc.querySelector('.covrfly-preorder-disclaimer');
      if (note && note.parentNode) note.parentNode.removeChild(note);
    }

    function injectPreorderProperty() {
      var form = getProductForm();
      if (!form) { LOG('WARN: form no encontrado para preorder property'); return; }
      if (!currentPreorderEntry) return;
      if (form.querySelector('.covrfly-preorder-property')) return;

      var R = calcPreorderRanges(currentPreorderEntry.blanksDate);

      var pedidoInput = document.createElement('input');
      pedidoInput.type = 'hidden';
      pedidoInput.name = 'properties[Pedido]';
      pedidoInput.value = 'Pre-Orden';
      pedidoInput.className = 'covrfly-preorder-property';
      form.appendChild(pedidoInput);

      var entregaInput = document.createElement('input');
      entregaInput.type = 'hidden';
      entregaInput.name = 'properties[Entrega estimada]';
      entregaInput.value = fmtDateRange(R.std.s, R.std.e);
      entregaInput.className = 'covrfly-preorder-property';
      form.appendChild(entregaInput);

      var adminInput = document.createElement('input');
      adminInput.type = 'hidden';
      adminInput.name = 'properties[_Tipo de orden]';
      adminInput.value = 'Pre-Orden (blanks: ' + currentPreorderEntry.blanksDate + ')';
      adminInput.className = 'covrfly-preorder-property';
      form.appendChild(adminInput);
    }

    function removePreorderProperty() {
      var inputs = document.querySelectorAll('.covrfly-preorder-property');
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].parentNode.removeChild(inputs[i]);
      }
    }

    function hideDynamicCheckout() {
      var form = getProductForm();
      if (form) form.classList.add('covrfly-hide-dynamic-checkout');
      var section = form ? form.closest('.product__info-container') || form.parentNode : null;
      if (section) section.classList.add('covrfly-hide-dynamic-checkout');
    }

    function showDynamicCheckout() {
      var els = document.querySelectorAll('.covrfly-hide-dynamic-checkout');
      for (var i = 0; i < els.length; i++) {
        els[i].classList.remove('covrfly-hide-dynamic-checkout');
      }
    }

    function applyPreorder() {
      currentlyPreorder = true;
      applyPreorderDelivery();
      setBtnPreorder();
      injectPreorderProperty();
      hideDynamicCheckout();
      LOG('\ud83d\udce6 Pre-Orden aplicado:', modelSelect ? modelSelect.value : '(sin modelo)',
          'blanks:', currentPreorderEntry ? currentPreorderEntry.blanksDate : '?');
    }

    function removePreorder() {
      currentlyPreorder = false;
      restorePreorderDelivery();
      setBtnOriginal();
      removePreorderProperty();
      showDynamicCheckout();
      LOG('\u2705 Pre-Orden removido');
    }

    function reinforcePreorder() {
      if (!currentlyPreorder) return;
      setBtnPreorder();
      injectPreorderProperty();
    }

    // ══════════════════════════════════════════════════════════
    // ── EVALUATE ─────────────────────────────────────────────
    // ══════════════════════════════════════════════════════════

    function evaluate() {
      var model = modelSelect ? modelSelect.value : '';
      var msVal = magsafeSelect ? magsafeSelect.value : '';

      var preEntry = getPreorderEntry(model, msVal);
      if (preEntry) {
        currentPreorderEntry = preEntry;
        if (!currentlyPreorder) applyPreorder();
      } else if (currentlyPreorder) {
        currentPreorderEntry = null;
        removePreorder();
      }

      if (isBlocked(model)) {
        applyBlock();
      } else if (currentlyBlocked) {
        removeBlock();
      }
    }

    // ══════════════════════════════════════════════════════════
    // ── INTERCEPTORES ────────────────────────────────────────
    // ══════════════════════════════════════════════════════════

    magsafeCard.addEventListener('click', function (e) {
      if (currentlyBlocked) {
        e.stopImmediatePropagation();
        e.preventDefault();
        LOG('Click bloqueado en tarjeta MagSafe');
      }
    }, true);

    magsafeCard.addEventListener('keydown', function (e) {
      if (currentlyBlocked && (e.key === 'Enter' || e.key === ' ')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);

    magsafeSelect.addEventListener('change', function () {
      if (guard) return;
      if (currentlyBlocked && magsafeSelect.value === 'Si') {
        if (pendingForce) clearTimeout(pendingForce);
        pendingForce = setTimeout(function () {
          pendingForce = null;
          if (currentlyBlocked) forceStandard();
        }, 20);
      }
      setTimeout(evaluate, 25);
      setTimeout(reinforcePreorder, 800);
    });

    if (modelSelect) {
      modelSelect.addEventListener('change', function () {
        if (isBlocked(modelSelect.value)) {
          magsafeSelect.value = 'No';
        }
        setTimeout(evaluate, 10);
        setTimeout(reinforcePreorder, 800);
      });
    }

    // ── INICIALIZACIÓN ─────────────────────────────────────
    evaluate();
    LOG('\u2705 v2.3.0 PDP listo');
    LOG('  MagSafe bloqueados:', BLOCKED_MAGSAFE_MODELS.join(', ') || '(ninguno)');
    PREORDER_MODELS.forEach(function (e) {
      var expired = isExpired(e);
      LOG('  ' + (expired ? '\u23f3 EXPIRADO' : '\ud83d\udce6 ACTIVO') + ':', e.model, 'blanks:', e.blanksDate);
    });
  }

  // Arranque
  function start() {
    waitForWrap(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* COVRFLY-SOLDOUT-BLOCK-END */
